import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Heading from '@bibliocommons/heading';
import { onlineResourceShape } from '@bibliocommons/bc-prop-types';
import ResourcesList from 'app/components/bibs/shared/ResourcesList';

export default function OnlineResources({ onlineResources, handleClick }) {
  if (onlineResources.size === 0) return null;

  return (
    <div className="cp-online-resources">
      <Heading tagName="h3" size="medium" variant>
        <FormattedMessage id="online_resources" />
      </Heading>
      <ResourcesList resources={onlineResources} handleClick={handleClick} />
    </div>
  );
}

OnlineResources.propTypes = {
  onlineResources: ImmutablePropTypes.listOf(onlineResourceShape).isRequired,
  handleClick: PropTypes.func
};
